var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 56,
    rx: 8,
    fill: "#38879F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 18.5C26.25 18.4337 26.2237 18.3701 26.1768 18.3232C26.1299 18.2763 26.0663 18.25 26 18.25H19C18.2707 18.25 17.5712 18.5397 17.0555 19.0555C16.5397 19.5712 16.25 20.2707 16.25 21V35C16.25 35.7293 16.5397 36.4288 17.0555 36.9445C17.5712 37.4603 18.2707 37.75 19 37.75H29C29.7293 37.75 30.4288 37.4603 30.9445 36.9445C31.4603 36.4288 31.75 35.7293 31.75 35V25.147C31.75 25.0807 31.7237 25.0171 31.6768 24.9702C31.6299 24.9233 31.5663 24.897 31.5 24.897H27C26.8011 24.897 26.6103 24.818 26.4697 24.6773C26.329 24.5367 26.25 24.3459 26.25 24.147V18.5ZM27 28.25C27.1989 28.25 27.3897 28.329 27.5303 28.4697C27.671 28.6103 27.75 28.8011 27.75 29C27.75 29.1989 27.671 29.3897 27.5303 29.5303C27.3897 29.671 27.1989 29.75 27 29.75H21C20.8011 29.75 20.6103 29.671 20.4697 29.5303C20.329 29.3897 20.25 29.1989 20.25 29C20.25 28.8011 20.329 28.6103 20.4697 28.4697C20.6103 28.329 20.8011 28.25 21 28.25H27ZM27 32.25C27.1989 32.25 27.3897 32.329 27.5303 32.4697C27.671 32.6103 27.75 32.8011 27.75 33C27.75 33.1989 27.671 33.3897 27.5303 33.5303C27.3897 33.671 27.1989 33.75 27 33.75H21C20.8011 33.75 20.6103 33.671 20.4697 33.5303C20.329 33.3897 20.25 33.1989 20.25 33C20.25 32.8011 20.329 32.6103 20.4697 32.4697C20.6103 32.329 20.8011 32.25 21 32.25H27Z",
    fill: "#38879F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 18.8235C27.75 18.6395 27.943 18.5225 28.086 18.6375C28.207 18.7355 28.316 18.8495 28.409 18.9795L31.422 23.1765C31.49 23.2725 31.416 23.3965 31.298 23.3965H28C27.9337 23.3965 27.8701 23.3701 27.8232 23.3232C27.7763 23.2764 27.75 23.2128 27.75 23.1465V18.8235Z",
    fill: "#38879F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2a13f6e3ac3f40682976ba176f970022.svg";
export { ForwardRef as ReactComponent };